import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as RefreshIcon } from "assets/icons/refresh-icon.svg";
import { useBusinessCompliance } from "contexts/business-compliance-context";
import { useUpdateQueryParams } from "hooks/useUpdateQueryParams";

import { Loader } from "ui/loader";
import { Paragraph2, Paragraph3 } from "ui/typography";

import { INoBusinessesProps } from "./types";

export const NoBusinesses = (props: INoBusinessesProps) => {
  const { setSearchQuery } = props;
  const { businessComplianceUILoading } = useBusinessCompliance();
  const updateQueryParams = useUpdateQueryParams();

  const handleRefreshBusinesses = () => {
    updateQueryParams({});
    setSearchQuery("");
  };

  return (
    <Box className="px-4 mt-[54px]">
      <Box className="h-[114px] flex flex-col gap-3">
        {businessComplianceUILoading ? (
          <Box className="h-16 flex items-center justify-center">
            <Loader hideLoadingText />
          </Box>
        ) : (
          <>
            <Box className="h-[78px] flex flex-col gap-2 px-3 w-full max-w-[260px]">
              <Paragraph2
                fontWeight="700"
                lineHeight="25.6px"
                textColor="#1A202C"
                className="text-center"
              >
                Nothing to see here
              </Paragraph2>
              <Paragraph3
                lineHeight="22.4px"
                textColor="#718096"
                className="text-center"
              >
                No businesses to review right now. Please check back later.
              </Paragraph3>
            </Box>
            <Box
              className="flex items-center justify-center gap-2 cursor-pointer"
              onClick={handleRefreshBusinesses}
            >
              <div>
                <RefreshIcon />
              </div>
              <Paragraph2
                lineHeight="24px"
                fontWeight="500"
                textColor="#00535C"
              >
                Refresh
              </Paragraph2>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
